/* eslint-disable */
import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CTitle, TTitle, STitle } from '../../components/Widget';
import ArrowImg from '../../../../../../assets/2025/arrow.gif';

import Img from '../../../../../../assets/cybersecurity2026/topic1600/risk/img.png';
import Img1 from '../../../../../../assets/cybersecurity2026/topic1600/risk/img_1.png';
import Img2 from '../../../../../../assets/cybersecurity2026/topic1600/risk/img_2.png';
import Img3 from '../../../../../../assets/cybersecurity2026/topic1600/risk/img_3.png';
import Img4 from '../../../../../../assets/cybersecurity2026/topic1600/risk/img_4.png';
import Img5 from '../../../../../../assets/cybersecurity2026/topic1600/risk/img_5.png';

import icon1 from '../../../../../../assets/finance/topic1600/section1-icon1.png';
import icon2 from '../../../../../../assets/finance/topic1600/section1-icon2.png';
import icon3 from '../../../../../../assets/finance/topic1600/section1-icon3.png';
import icon4 from '../../../../../../assets/finance/topic1600/section1-icon4.png';
import icon5 from '../../../../../../assets/finance/topic1600/section1-icon5.png';

import { useUpdateComponentState } from '../../../hooks';
import { useStore } from '../../../../store';
import arrow from '../../../../../../assets/2025/arrow.gif';
import phishing from '@/assets/finance/topic1600/section1-bg1.png';
import phishing1 from '@/assets/finance/topic1600/section1-bg8.png';
import sectionBg1 from '../../../../../../assets/finance/topic1600/section1-bg2.png';
import topBox from '../../../../../../assets/finance/topic1600/section1-bg3.png';
import topBox1 from '../../../../../../assets/finance/topic1600/section1-bg4.png';
import internalThreatsImg from '../../../../../../assets/finance/topic1600/section1-bg8.png';

interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const { language } = useStore();
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const [state, setState] = React.useState({
    play: 1,
    isPlayed: false,
  });
  const [falsifyClicked, setFalsifyClicked] = useState<
    [boolean, boolean, boolean]
  >([false, false, false]);
  const falsifyArrowStep = useMemo<1 | 2 | 3 | 4>(() => {
    if (!falsifyClicked[0]) return 1;
    if (!falsifyClicked[1]) return 2;
    if (!falsifyClicked[2]) return 3;
    return 4; // 全部点击后隐藏
  }, [falsifyClicked]);

  const bg: { [key: number]: string } = {
    1: topBox,
    2: topBox1,
  };

  // 点击箭头图标时触发动画
  const handleArrowClick = () => {
    if (!animationStarted) {
      setAnimationStarted(true);
      // 从第二条开始显示（第一条已经显示）
      setVisibleCount(2);
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'finance-topic1600-section1-1'
      );
    }
  };

  const handleArrowClick1 = () => {
    if (!animationStarted1) {
      setAnimationStarted1(true);
      // 从第二条开始显示（第一条已经显示）
      setVisibleCount1(2);
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'finance-topic1600-section1-2'
      );
    }
  };

  // 渲染内容列表
  const renderContentList = (contentList: any[], i: number) => (
    <div className="content-list">
      {contentList?.map((item, index) => (
        <div key={item.id + index} className="content-item">
          <div className={`content-left content-left-${i}`}>{item.title}</div>
          <div className="content-right">{item.text}</div>
        </div>
      ))}
    </div>
  );

  const riskToImg = (no: 0 | 1 | 2 | 3 | 4 | 5): string => {
    const imgMap: Record<0 | 1 | 2 | 3 | 4 | 5, string> = {
      0: Img,
      1: Img1,
      2: Img2,
      3: Img3,
      4: Img4,
      5: Img5,
    };
    return imgMap[no];
  };

  const riskToImg1 = (no: 1 | 2 | 3 | 4 | 5): string => {
    const imgMap: Record<1 | 2 | 3 | 4 | 5, string> = {
      1: icon1,
      2: icon2,
      3: icon3,
      4: icon4,
      5: icon5,
    };
    return imgMap[no];
  };

  const updateComponentState = useUpdateComponentState();
  const [visibleCount, setVisibleCount] = useState(1); // 默认显示第一条
  const [visibleCount1, setVisibleCount1] = useState(1); // 默认显示第一条
  const [animationStarted, setAnimationStarted] = useState(false); // 控制动画是否已开始
  const [animationStarted1, setAnimationStarted1] = useState(false); // 控制动画是否已开始


  React.useEffect(() => {
    // 如果动画还未开始，则不自动播放
    if (!animationStarted) return;

    // 如果已经显示完所有项目，则停止
    if (visibleCount >= paragraphsSettings.risks?.length) return;

    const timer = setTimeout(() => {
      setVisibleCount((v) => v + 1);
    }, 600);

    return () => clearTimeout(timer);
  }, [visibleCount, animationStarted, paragraphsSettings.risks?.length]);

  React.useEffect(() => {
    // 如果动画还未开始，则不自动播放
    if (!animationStarted1) return;

    // 如果已经显示完所有项目，则停止
    if (visibleCount1 >= paragraphsSettings.internalThreats?.length) return;

    const timer = setTimeout(() => {
      setVisibleCount1((v) => v + 1);
    }, 600);

    return () => clearTimeout(timer);
  }, [
    visibleCount1,
    animationStarted1,
    paragraphsSettings.internalThreats?.length,
  ]);

  return (
    <div className="topic-section-1">
      <div className="tampering">
        <CTitle title={paragraphsSettings?.title} />
        <div>
          <STitle title={paragraphsSettings?.subTitle} />
        </div>
        <i className="back_piece"></i>
        <div className="content" id="finance-topic1600-section1-1">
          {!animationStarted && (
            <img className="arrow-img" src={arrow} alt="" />
          )}

          <div className="right-pic">
            <div className="risks-title">{paragraphsSettings?.risksTitle}</div>
            <img src={phishing} alt="" />
          </div>
          <div className="left-list" onClick={handleArrowClick}>
            {paragraphsSettings.risks?.map((r: any, i: number) => (
              <div
                key={i}
                className="risk-item"
                data-show={i < visibleCount}
                style={{
                  cursor: i === 0 && !animationStarted ? 'pointer' : 'default',
                }}
              >
                <div className="risk-title">
                  <img className="risk-img" src={riskToImg(i as any)} alt="" />
                  <span>{r.title}</span>
                </div>
                <div className="risk-desc">
                  <div className="risk-desc-text">{r.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="example_content_container">
        <div className="example_content">
          <img className="example_content_img" src={sectionBg1} alt="" />
          <div className="example_content_con">
            {paragraphsSettings.dataSourceText}
          </div>
          <div className="data_source">
            {paragraphsSettings.dataSource}
            <a
              className="network_link"
              target="_blank"
              rel="noreferrer"
              href={paragraphsSettings.link}
            >
              {paragraphsSettings.linkLabel}
            </a>
          </div>
        </div>
        <div className="account-management">
          <i className="back_piece"></i>
          <div className="content" id="finance-topic1600-section1-2">
            {!animationStarted1 && (
              <img className="arrow-img" src={arrow} alt="" />
            )}
            <div className="left-list" onClick={handleArrowClick1}>
              {paragraphsSettings.internalThreats?.map((r: any, i: number) => (
                <div
                  key={i}
                  className="risk-item"
                  data-show={i < visibleCount1}
                  style={{
                    cursor:
                      i === 0 && !animationStarted1 ? 'pointer' : 'default',
                  }}
                >
                  <div className="risk-title">
                    <img src={riskToImg1(r.imgNum)} alt="" />
                    <div>{r.title}</div>
                  </div>
                  <div className="risk-desc">{r.desc}</div>
                </div>
              ))}
            </div>
            <div className="right-pic">
              <img src={phishing1} alt="" />
            </div>
          </div>
        </div>
      </div>

      {paragraphsSettings.CaseList.map((item: any, index: any) => (
        <div className="tabs-content" key={index}>
          <div className="chat-con">{item.caseTitle}</div>
          <div className="top-box">
            <img className="top-box-img" src={bg[item.img]} alt="" />
          </div>
          <div className="tabs-style">
            <h3>{item?.l5}</h3>
            <div
              className="tab-a-title"
            >
              {item?.l6}
            </div>
            <div className="tab-a-content">
              <div className="tab-a-content-left" />
              <div className="tab-a-content-right">
                {renderContentList(item?.caseContent, index)}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Section1;
